import { render, staticRenderFns } from "./seckill-signup.vue?vue&type=template&id=53f5454f&scoped=true"
import script from "./seckill-signup.vue?vue&type=script&lang=js"
export * from "./seckill-signup.vue?vue&type=script&lang=js"
import style0 from "./seckill-signup.vue?vue&type=style&index=0&id=53f5454f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f5454f",
  null
  
)

export default component.exports